export default {
    id: "e653e400-6394-4247-82e6-4e45f238aefc",
    icon: "mdi-arrow-left-right",
    name: "shapeDoubleArrow",
    title: "Shape Double Arrow",
    description: "A block double arrow",
}